module.exports = __webpack_public_path__ + "media/events/2020Show-ed379072.jpg";